import FilterManager from "./filterManager";
export class FormStateFilter {
    constructor() {
        //we need to this for the no results form and the paginated SPA SRP
        document.addEventListener("do.vehiclesearchend", () => {
            this.initialize();
        });
        //sadly, we need this for infinite scroll SPA SRP
        document.addEventListener("do.vehicleloadend", () => {
            this.initialize();
        });
        this.initialize();
    }
    initialize() {
        //we set this attribute in the StateFilter constructor to avoid double initialization
        const formsList = document.querySelectorAll("form:not([state-field-set])");
        formsList.forEach((form) => {
            new FilterManager(form);
        });
    }
}
window.DoUtility.SelfInstantiateOnLoad(FormStateFilter);
